import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CancelOrderService } from '../../services/cancel-order.service';
import { CancelOrderGarment } from '../../models/cancel-order.model';
import { GtrakAuthService } from "../../../authentication/services/gtrak-auth.service";
import { RequestParams } from '../../../../common/rest-api/models/request-params';
@Component({
    selector: 'app-customer-cancel-order-page',
    templateUrl: 'customer-cancel-order.page.html',
    styleUrls: [
      './customer-cancel-order.page.scss',
    ]
  })
  export class CustomerCancelOrderPage implements OnInit {

    constructor(
      private router: Router,
      public authService: GtrakAuthService,
      private route: ActivatedRoute,
      private cancelOrderService: CancelOrderService,
    ) { }

    cancelOrders: any[] = [];
    totalLossCharge: number = 0;
    loaded: boolean=false;
    requestParams:any;
    customerName:string;
    customerId:string;
    currentDate = new Date();
    public viewChange: boolean = false;
    async ngOnInit() {
      
      this.loaded = false;
      this.requestParams = new RequestParams();
      this.customerId=this.route.snapshot.params.id;
     if(this.authService.user.isCostCenterUser){
      this.requestParams.filters.CostCenterUser=localStorage.getItem('CostCenterUser');
     }
      await this.cancelOrderService.getForCustomer(this.route.snapshot.params.id,this.requestParams).then((cancelOrder) => {
        this.cancelOrders = cancelOrder;
      });
   if(this.cancelOrders!=undefined){
      if(this.cancelOrders.length>0){
          
          if(this.cancelOrders[0].length>0){
            this.customerName=this.cancelOrders[0][0].customerName;
            }
        }
      for (let i = 0; i < this.cancelOrders.length; i++) {
        let woLossCharge = 0;
        const cancelOrderGarments = this.cancelOrders[i] as unknown as CancelOrderGarment[];
        for (let j = 0; j < cancelOrderGarments.length; j++) {
          if(cancelOrderGarments[j].dateCollected === null) {
            woLossCharge += parseFloat(cancelOrderGarments[j].lossCharge);
            this.totalLossCharge += parseFloat(cancelOrderGarments[j].lossCharge);
            //round to 2 decimal places
            woLossCharge = Math.round(woLossCharge * 100) / 100;
            this.totalLossCharge = Math.round(this.totalLossCharge * 100) / 100;
          }
        }
        this.cancelOrders[i].lossCharge = woLossCharge;
      }

    }
      this.loaded = true;
    }
 changePrinterView(): void {
  this.loaded=false;
    this.viewChange = !this.viewChange;
    // Set a delay before opening the print dialog
    setTimeout(() => {
      print();
    }, 1000); // 2000 milliseconds = 2 seconds
      this.loaded=true;
  }
  }